jQuery(function( $ ){


$('.ctm-sec5_list').slick({
     infinite: false,
  dots: false,
  nav:true,
  speed: 300,
     slidesToScroll: 3,
    autoplay: false,
  slidesToShow: 3,
  prevArrow: '<i class="fa fa-angle-left" aria-hidden="true"></i> <span class="icon icon-arrow-right" aria-hidden="true"></span>',
  nextArrow: '<i class="fa fa-angle-right" aria-hidden="true"></i> <span class="icon icon-arrow-right" aria-hidden="true"></span>',

    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}); 
  
});